var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",function(){return [_c('v-btn',{staticClass:"ma-1",class:_vm.cssClass,attrs:{"v-bind":_vm.$attrs},on:{"click":function($event){return _vm.createOrder()}}},[_vm._v(_vm._s(_vm.label))])]},{"createOrder":_vm.createOrder})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }